import React from 'react';
import { Button } from 'ui-components/components/button';
import { ordinalOfAnchorStartTag, ordinalOfAnchorEndTag } from '../alert-description-helper';

import PropTypes from 'prop-types';

export const AnchorEmbeddedCustomAlert = ({ onClick, orderNumber, content = '' }) => {
  if (!content.length) {
    return null;
  }

  const whereAncorTagBegins = ordinalOfAnchorStartTag(content);
  const whereAnchorTagEnds = ordinalOfAnchorEndTag(content);
  const firstPartOfContent = content.substring(0, whereAncorTagBegins);
  const remainderOfContent = content.substring(whereAnchorTagEnds, content.length);

  return (
    <React.Fragment>
      {/* oxlint-disable-next-line react/no-danger */}
      <span dangerouslySetInnerHTML={{ __html: firstPartOfContent }} />
      <Button onClick={onClick} theme='link'>
        {orderNumber}
      </Button>
      {/* oxlint-disable-next-line react/no-danger */}
      <span dangerouslySetInnerHTML={{ __html: remainderOfContent }} />
    </React.Fragment>
  );
};

AnchorEmbeddedCustomAlert.propTypes = {
  onClick: PropTypes.func.isRequired,
  orderNumber: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};
